<template>
  <form id="arnSchritt4FormEndkunde" novalidate>
     <div class="my-4"> 
         <div class="bgTR px-4 px-lg-5 py-4 py-lg-5 justify-content-">
             <div class="schritt-zaehler-position">
                 <SchritteZaehler class="w-100"></SchritteZaehler>
             </div>
             <h3 class="pb-3 w-100 text-start">Abschluss des Vertrages</h3>    

             <!-- Übersicht der zu versichernden Personen -->
             <div class="boxTR px-4 px-lg-5 py-3 py-lg-4 w-100 font-base-links">
                 
                 <ArnBerechnungKachel 
                     :items="store.items" 
                     :vndaten="store.vndaten"
                     :versicherungsbeginn="store.versicherungsbeginn"
                     :geburtsdatumAeltestePerson="store.geburtsdatumAeltestePerson"
                 />
             </div>

             <div class="boxTR mt-4 px-4 px-lg-5 py-3 py-lg-4 w-100 font-base-links">
                 <div class="my-4">
                     <div class="form-group">
                         <div class="form-check form-check-inline mb-3">
                             <input class="form-check-input" type="checkbox" id="ewe4" name="ewe4" v-model="store.kenntnisnahme">
                             <label class="form-check-label" for="ewe4">
                             Ich bestätige die Kenntnisnahme des gewählten Leistungsumfanges: *
                             </label>
                         </div>
                     </div>
                     
                     <!-- ARNS Beschreibung -->
                     <div v-if="isARNS" class="mb-5">
                        <h1 class="font-base-links"><b><em>vigo</em></b> Auslandsreise.Nachhaltigkeit (Einzelversicherung):</h1>
                        <div class="ms-3 ms-md-5">
                            <ul class="ms-3">
                                <li class="mt-3">Der Tarif gilt für Reisen mit einer geplanten Reisedauer von bis zu 8 Wochen</li>
                                <li class="mt-3">Heilbehandlungen, Arznei- und Verbandmittel bei Krankheiten und Unfällen, die auf der Reise akut auftreten. Akzeptiert werden auch Behandlungen von Heilpraktikern, Osteopathen und Chiropraktikern</li>
                                <li class="mt-3">Transport zum Behandler und zurück in die Unterkunft</li>
                                <li class="mt-3">Medizinisch sinnvoller und vertretbarer Rücktransport nach Deutschland</li>
                                <li class="mt-3">Unterbringung, Verpflegung und Behandlung bei einem Krankenhausaufenthalt</li>
                                <li class="mt-3">Rooming-in bei mitversicherten Kindern</li>
                                <li class="mt-3">Anreise Angehöriger bei länger andauerndem stationärem Aufenthalt</li>
                                <li class="mt-3">Automatische Verlängerung des Versicherungsschutzes, wenn Rückreise aus medizinischen Gründen oder pandemiebedingt verschoben werden muss</li>
                                <li class="mt-3">Suche, Rettung, Bergung bis zu 10.000 €</li>
                                <li class="mt-3">Überführung oder Bestattung (im Todesfall)</li>
                                <li class="mt-3">Psychologische Betreuung bei Terror oder Todesfall</li>
                            </ul>
                        </div>
                     </div>
                     
                     <!-- ARNF Beschreibung -->
                     <div v-if="isARNF" class="mb-5">
                        <h1 class="font-base-links"><b><em>vigo</em></b> Auslandsreise.Nachhaltigkeit (Familienversicherung):</h1>
                        <div class="ms-3 ms-md-5">
                            <ul class="ms-3">
                                <li class="mt-3">Der Tarif gilt für Reisen mit einer geplanten Reisedauer von bis zu 8 Wochen</li>
                                <li class="mt-3">Heilbehandlungen, Arznei- und Verbandmittel bei Krankheiten und Unfällen, die auf der Reise akut auftreten. Akzeptiert werden auch Behandlungen von Heilpraktikern, Osteopathen und Chiropraktikern</li>
                                <li class="mt-3">Transport zum Behandler und zurück in die Unterkunft</li>
                                <li class="mt-3">Medizinisch sinnvoller und vertretbarer Rücktransport nach Deutschland</li>
                                <li class="mt-3">Unterbringung, Verpflegung und Behandlung bei einem Krankenhausaufenthalt</li>
                                <li class="mt-3">Rooming-in bei mitversicherten Kindern</li>
                                <li class="mt-3">Anreise Angehöriger bei länger andauerndem stationärem Aufenthalt</li>
                                <li class="mt-3">Automatische Verlängerung des Versicherungsschutzes, wenn Rückreise aus medizinischen Gründen oder pandemiebedingt verschoben werden muss</li>
                                <li class="mt-3">Suche, Rettung, Bergung bis zu 10.000 €</li>
                                <li class="mt-3">Überführung oder Bestattung (im Todesfall)</li>
                                <li class="mt-3">Psychologische Betreuung bei Terror oder Todesfall</li>
                                <li class="mt-3">Versicherungsschutz für die ganze Familie (Versicherungsnehmer, Ehepartner/Lebenspartner und alle Kinder bis zum vollendeten 25. Lebensjahr)</li>
                            </ul>
                        </div>
                     </div>
                 </div>
             </div>
             

             <div class="boxTR mt-4 px-4 px-lg-5 py-3 py-lg-4 w-100 font-base-links">
                 <h1 class="font-lg-links-bold mb-3">Einwilligungserklärungen</h1>
                 <b>Einwilligungserklärung in die Datenverarbeitung (auch durch Dritte) und weitere Erklärungen *</b>
                 <div class="form-group">
                     <div class="form-check form-check-inline mb-3 mt-3">
                         <input class="form-check-input" type="checkbox" id="ewe1" name="ewe1" v-model="store.eweSozialdaten">
                         <label class="form-check-label" for="ewe1">
                          {{ ewe1LabelText }}                </label>
                     </div>
                 </div>
             </div>

             <div class="v4y-einwilligung-box mt-4 w-100">
                 <div class="mx-4 py-3">
                     <div class="pb-3">
                         <b>Einwilligungserklärung zu Kontaktzwecken (optional)</b>
                     </div>
                     <div class="form-group">
                         <div class="form-check form-check-inline">
                             <input class="form-check-input" type="checkbox" id="eweKontakt" name="eweKontakt" v-model="store.eweKontakt">
                             <label class="form-check-label" for="eweKontakt">
                                 Ich willige ein, dass mich die <em><b>vigo</b></em> Krankenversicherung und ihre Vermittler telefonisch und per E-Mail über Versicherungsprodukte informieren dürfen. Dies gilt unabhängig davon, ob ein Vertrag besteht. Ein Widerruf für die Zukunft ist jederzeit möglich. 
                             </label>
                         </div>
                     </div>
                 </div>
             </div>
             
             <div class="mt-4 w-100 d-flex justify-content-end">
                 <OnlineZahlungspflichtigAbschliessenButton 
                     data-shake="true"
                     :disabled="submitDisabled"
                     :isLoading="vertragStore.isSubmitting"
                     @click="handleAbschliessen"
                 />
             </div>
         </div>
     </div>

     
   </form>
 </template>
 
 <script setup>
 import { onMounted, computed, nextTick } from 'vue';
 import { formValidation } from '@form-validation/bundle/popular';
 import { Bootstrap5 } from '@form-validation/plugin-bootstrap5';
 import { Trigger } from '@form-validation/plugin-trigger';
 import { useRechnerStore } from '@/stores/rechner';
 import { useMainStore } from '@/stores/useMainStore.js';
 import { useVertragStore } from '@/stores/vertrag.js';
 import { useAntragStore } from '@/stores/antrag.js';
 import { createVertrag, downloadVersicherungsschein } from '@/api/VertragService.js';
 import SchritteZaehler from '@/components/general/schritte_zaehler.vue';
 import OnlineZahlungspflichtigAbschliessenButton from '@/components/online_zahlungspflichtig_abschliessen_button.vue';
 import ArnBerechnungKachel from '@/components/arn/arn_berechnung_kachel.vue';
 
 
 const store = useRechnerStore();
 const mainStore = useMainStore();
 const vertragStore = useVertragStore();
 const antragStore = useAntragStore();
 
 let fv = null;

 const ewe1LabelText = computed(() => {
  if (mainStore.kanal === 'meinevigo') {
    return 'Einwilligung in Erhebung und Verwendung von Gesundheitsdaten sowie Schweigepflichtentbindungserklärung, außerdem weitere zusätzliche Erklärungen (siehe PDF-Dokument Vertragsgrundlagen und Erklärungen).';
  }
  return 'Einwilligung in Erhebung und Verwendung von Gesundheitsdaten, Sozialdaten der AOK Rheinland/Hamburg sowie Schweigepflichtentbindungserklärung, außerdem weitere zusätzliche Erklärungen (siehe PDF-Dokument Vertragsgrundlagen und Erklärungen).';
});

 // ARN-spezifisch: Prüfen ob ARNS (tarif7) oder ARNF (tarif8)
 const isARNS = computed(() => {
   const firstItem = store.items[0];
   return firstItem?.tarif7 === 1;
 });

 const isARNF = computed(() => {
   const firstItem = store.items[0];
   return firstItem?.tarif8 === 1;
 });
 
 // Computed für Button-States
 const submitDisabled = computed(() => {
   return vertragStore.hasSubmit || vertragStore.isSubmitting;
 });
 
 const shouldShowRdnummerInfo = computed(() => {
   // Nur anzeigen wenn Feature enabled UND RD-Nummer vorhanden (nicht 0)
   return mainStore.aokEnabled && store.aok !== 0
 });
 
 // Submit-Handler
 const handleAbschliessen = async () => {
   console.log('[ARNSchritt4Endkunde] handleAbschliessen wird aufgerufen');
   
   if (!fv) {
     console.error('[ARNSchritt4Endkunde] FormValidation nicht initialisiert!');
     return;
   }
   
   const button = document.querySelector('[data-shake="true"]');
   console.log('[ARNSchritt4Endkunde] Button gefunden:', !!button);
   
   // Validierung prüfen
   console.log('[ARNSchritt4Endkunde] Starte Validierung...');
   const status = await fv.validate();
   console.log('[ARNSchritt4Endkunde] Validierungsstatus:', status);
   
   if (status !== 'Valid') {
     // Validation failed - shake button
     console.log('[ARNSchritt4Endkunde] Validierung fehlgeschlagen - Shake-Animation');
     if (button) {
       button.classList.add('shake');
       setTimeout(() => button.classList.remove('shake'), 500);
     }
     nextTick(() => {
       const firstInvalid = document.querySelector('#arnSchritt4FormEndkunde .is-invalid');
       if (firstInvalid) {
         firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
       }
     });
     return;
   }
   
   // Validation erfolgt - API-Call starten
   console.log('[ARNSchritt4Endkunde] Vertragsabschluss wird gestartet...');
   
   // Loading-State aktivieren
   vertragStore.isSubmitting = true;
   vertragStore.resetError();
   
   try {
     // API-Call: Vertrag anlegen
     const result = await createVertrag(antragStore.antragId);
     
     if (!result.success) {
       // Fehler beim Anlegen des Vertrags
       console.error('[ARNSchritt4Endkunde] Fehler beim Vertrag:', result.error);
       vertragStore.errorMessage = result.error;
       vertragStore.isSubmitting = false;
       // Navigation zu Schritt5 mit Fehleranzeige
       store.resetVertragsdokumentDownloadStatus();
       store.stepStatus = 5;
       return;
     }
     
     // Erfolg - Speichere Daten im RechnerStore
     console.log('[ARNSchritt4Endkunde] Vertrag erfolgreich angelegt');
     store.vertragsnummer = result.vertragsnummer;
     store.secretstring = result.secret;
     store.antragAbgeschickt = true;
     
     // Auch im VertragStore speichern
     vertragStore.vertragsnummer = result.vertragsnummer;
     vertragStore.secretstring = result.secret;
     vertragStore.hasSubmit = true;
     
     console.log('[ARNSchritt4Endkunde] Warte 5 Sekunden vor Versicherungsschein-Download...');
     
     // 5 Sekunden warten (analog zur alten Implementierung)
     await new Promise(resolve => setTimeout(resolve, 5000));
     
     // Automatischer Download des Versicherungsscheins
     console.log('[ARNSchritt4Endkunde] Starte Versicherungsschein-Download...');
     const downloadResult = await downloadVersicherungsschein(result.vertragsnummer, result.secret);
     
     if (!downloadResult.success) {
       console.error('[ARNSchritt4Endkunde] Versicherungsschein-Download fehlgeschlagen:', downloadResult.error);
       // Fehler wird geloggt, aber wir navigieren trotzdem weiter
       // Der User kann auf der Erfolgsseite erneut herunterladen
     }
     
     // Navigation zu Erfolgsseite
     vertragStore.isSubmitting = false;
     console.log('[ARNSchritt4Endkunde] Navigation zu stepStatus = 5');
     store.resetVertragsdokumentDownloadStatus();
     store.stepStatus = 5;
     
   } catch (error) {
     console.error('[ARNSchritt4Endkunde] Unerwarteter Fehler:', error);
     vertragStore.errorMessage = error.message || 'Ein unerwarteter Fehler ist aufgetreten';
     vertragStore.isSubmitting = false;
     // Navigation zu Schritt5 mit Fehleranzeige
     store.resetVertragsdokumentDownloadStatus();
     store.stepStatus = 5;
   }
 };
 
 // FormValidation initialisieren
 onMounted(async () => {
     await nextTick()
     
     console.log('[ARNSchritt4Endkunde] onMounted wird ausgeführt');
     console.log('[ARNSchritt4Endkunde] store.aok:', store.aok);
     console.log('[ARNSchritt4Endkunde] antragStore.antragId:', antragStore.antragId);
     
     const formElement = document.getElementById('arnSchritt4FormEndkunde');
     
     if (!formElement) {
         console.error('[ARNSchritt4Endkunde] Form-Element nicht gefunden!');
         return;
     }
     
     console.log('[ARNSchritt4Endkunde] Form-Element gefunden');
     
     const fields = {
       ewe4: {
         validators: {
           choice: {
             message: 'Bitte bestätigen Sie die Kenntnisnahme des gewählten Leistungsumfanges.',
             min: 1,
           },
         },
       },
       ewe1: {
         validators: {
           choice: {
             message: 'Bitte akzeptieren Sie die Einwilligungserklärung in die Datenverarbeitung und weitere Erklärungen.',
             min: 1,
           },
         },
       },
     };

     
     fv = formValidation(formElement, {
       locale: 'de_DE',
       fields,
       plugins: {
         bootstrap5: new Bootstrap5({
           rowSelector: '.form-group, .form-check, .form-check-inline'
         }),
         trigger: new Trigger({
           event: 'blur change',
         }),
       },
     });
     
     console.log('[ARNSchritt4Endkunde] FormValidation initialisiert');
 });
 </script>
 
 <style scoped>
     .introclaim {
         margin-bottom: 1.5rem;
     }
     .platziert {
         position: absolute;
         right:0;
         top:0;
         transform: translate(-20%,-50%);
     }


     .schritt-zaehler-position {
     position: absolute;
     top: 0;
     left: 50%;
     transform: translate(-50%, -50%);
     width: 90vw;
     }

     @media (min-width: 768px) {
     .schritt-zaehler-position {
         width: 80vw;
     }
     }

     @media (min-width: 992px) {
     .schritt-zaehler-position {
         width: 70vw;
     }
     }

     @media (min-width: 1200px) {
     .schritt-zaehler-position {
         width: 60vw;
     }
     }

     h3 {
         color: #000;
         font-family: "Source Sans Pro";
         font-size: 22px;
         font-style: normal;
         font-weight: 700;
         line-height: 160%;
         text-align: left;
     }

     @keyframes shake {
         0%, 100% { transform: translateX(0); }
         10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
         20%, 40%, 60%, 80% { transform: translateX(5px); }
     }

     .shake {
         animation: shake 0.5s ease-in-out;
     }

     /* Initialer Rand für Pflicht-Checkboxen zur besseren Sichtbarkeit */
#arnSchritt4FormEndkunde .form-check-input#ewe1:not(.is-invalid),
#arnSchritt4FormEndkunde .form-check-input#ewe4:not(.is-invalid),
#arnSchritt4FormEndkunde .form-check-input#eweKontakt:not(.is-invalid) {
  border: 2px solid var(--vigo-6-600-border);
}
 </style>
